import { convertQuoteToPolicyInternal } from '../requests/internal';
import { createMutation } from '../store';

// TODO: Should maybe be called payed later
export const useConvertQuoteToPolicy = createMutation({
  request: convertQuoteToPolicyInternal
});
